export const Constants = {
  TAG_NAME: 'pop-pc-filter-chips-component',
  TRANSLATION_KEYS: {
    RESET_FILTERS: 'filters.reset_filters',
    SHOW_LESS: 'filters.show_less',
    SHOW_PLUS: 'filters.show_plus',
    YOUR_SELECTIONS_LABEL: 'filters.your_selections',
  },
  CHIPS_LIMIT: 5,
  FUNCTION_TYPEOF: 'function',
};
